import React from 'react';
import { CollectionPageLoader } from '~/components/ui/molecules/skeleton-loaders/CollectionPageLoader';
import Skeleton from 'react-loading-skeleton';
import { WebstoreSkeletonTheme } from '~/components/ui/organisms/WebstoreSkeletonTheme';

export const GenericSiteSkeleton: React.FC = () => (
  <div className={'site-wrapper'}>
    <WebstoreSkeletonTheme>
      <div className="container">
        <div className="mt-5 mb-5 flex justify-between items-center">
          <Skeleton circle style={{ height: '70px', width: '70px' }} />
          <Skeleton style={{ height: '40px', width: '250px' }} />
        </div>
        <div className="mt-5 mb-5">
          <Skeleton style={{ height: '300px' }} />
        </div>
        <div className={'grid grid-cols-4 md:grid-cols-12 gap-4 md:gap-5 mt-7'}>
          <CollectionPageLoader totalThumbs={8} />
        </div>
      </div>
    </WebstoreSkeletonTheme>
  </div>
);
